import React, { Component } from "react";
import store from "../../redux/store";
import { Col, Modal, ModalFooter, Row } from "reactstrap";
import { withRouter } from "../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { MenuWithBreadScrum } from "../menu/MenuWithBreadScrum";
import { Autocomplete } from "@mui/material";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { InputAdornment } from "@mui/material";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@mui/icons-material/Search";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DatePicker from "react-datepicker";
import SaveButton from "../buttons/SaveButton";
import CancelIconButton from "../buttons/CancelIconButton";
import FetchServerData from "../../provider/FetchServerData";
import PtsButton from "../buttons/PtsButton";
import BackButton from "../buttons/BackButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import Utils from "../../provider/Utils";
import ApplicationStateAction from "../../redux/applicationState/ApplicationStateAction";
import "./ReturnablePlan.css";
import CreateButton from "../buttons/CreateButton";
import Pagination from "../assetTracking/Pagination";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import _ from "lodash";
import RemoveIconButton from "../buttons/RemoveIconButton";
class ReturnablePlan extends Component {
  header = store.getState().header.header;
  customerList = store.getState().customer.customerList;
  organizationAddress =
    store.getState().organization?.organization?.organizationAddress;
  returnableAssetState = store.getState().applicationState.returnableAssetState;
  returnableAssetCycleState =
    store.getState().applicationState.returnableAssetCycleState;
  returnableAssetStateDetails = {};
  returnableAssetCycleStateDetails = {};
  trackActions = [
    { type: "IN", id: 1 },
    { type: "OUT", id: 2 },
  ];
  constructor(props) {
    super(props);
    let breadCrumb = [
      { pageid: "/returnablePlanList", uiname: "Returnable Plan List" },
      { pageid: "", uiname: "Returnable Plan Details" },
    ];
    let assetCycleBreadCrumb = [
      { pageid: "/assetCycleList", uiname: "Asset Cycle List" },
      { pageid: "/assetCycle", uiname: "Asset Cycle Details" },
      { pageid: "", uiname: "Returnable Plan Details" },
    ];
    let action = "";
    let returnableCyclePlanId = "";
    let assetId = "";
    let assetCycleId = "";
    let pageId = "";
    if (!action && props.state) {
      action = props.state.action;
      returnableCyclePlanId = props.state.returnableCyclePlanId;
      assetId = props.state.assetId;
      assetCycleId = props.state.assetCycleId;
      pageId = props.state.pageId;
    }
    console.log(returnableCyclePlanId);
    if (pageId === "assetCycleDetails") {
      this.breadCrumb = assetCycleBreadCrumb;
    } else {
      this.breadCrumb = breadCrumb;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "update")
      )
    ) {
      this.getReturnablePlanDetails(returnableCyclePlanId, 0, 10, "");
    }

    if (this.returnableAssetState) {
      this.returnableAssetStateDetails = Object.getOwnPropertyNames(
        this.returnableAssetState
      );
    }
    if (this.returnableAssetCycleState) {
      this.returnableAssetCycleStateDetails = Object.getOwnPropertyNames(
        this.returnableAssetCycleState
      );
    }

    if (this.returnableAssetStateDetails.length > 0) {
      this.state = {
        action: action,
        returnableCyclePlanId: this.returnableAssetState.returnablePlanId,
        assetId: this.returnableAssetState.assetId,
        name: "",
        description: "",
        planDate: new Date(),
        customer: null,
        customerId: "",
        searchText: "",
        initialPage: this.returnableAssetState.initialPage,
        pageSize: this.returnableAssetState.pageSize,
        isAssetListPaging: false,
        isAssetCycleListPaging: false,
        render: false,
        openListModal: false,
        openManualTrack: false,
        isTrackAtBaseLocation: false,
        isSourceBaselocation: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        allPlanAssetsSelected: false,
        allCheckBoxSelected: false,
        allAssetCheckBoxSelected: false,
        assetIds: [],
        planAssets: [],
        assetCyclesList: [],
        assetList: [],
        manulAssetHistoryList: [],
        customerLocationList: [],
        custDestinaionLocationList: [],
        custLocations: [],
        custLocation: null,
        custSourceAddress: null,
        custDestinationAddress: null,
        selectedPlanAssetList: new Set(),
        selectedAssetList: new Set(),
        selectedAssetCycleList: new Set(),
        trackAction: null,
        showToolbarBtn: false,
        showMultipleDeleteToolbarBtn: false,
        deleteAssetsOpen: false,
      };
    } else if (this.returnableAssetCycleStateDetails.length > 0) {
      this.state = {
        action: action,
        pageId: pageId,
        returnableCyclePlanId: this.returnableAssetCycleState.returnablePlanId,
        assetCycleId: this.returnableAssetCycleState.assetCycleId,
        name: "",
        description: "",
        planDate: new Date(),
        customer: null,
        customerId: "",
        searchText: "",
        initialAssetCyclePage: this.returnableAssetCycleState.initialPage,
        pageSize: this.returnableAssetCycleState.pageSize,
        isAssetListPaging: false,
        isAssetCycleListPaging: false,
        render: false,
        openListModal: false,
        openManualTrack: false,
        isTrackAtBaseLocation: false,
        isSourceBaselocation: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        allCheckBoxSelected: false,
        allPlanAssetsSelected: false,
        allAssetCheckBoxSelected: false,
        assetIds: [],
        planAssets: [],
        assetCyclesList: [],
        assetList: [],
        manulAssetHistoryList: [],
        customerLocationList: [],
        custSourceLocationList: [],
        custDestinaionLocationList: [],
        custLocations: [],
        custLocation: null,
        custSourceAddress: null,
        custDestinationAddress: null,
        selectedPlanAssetList: new Set(),
        selectedAssetList: new Set(),
        selectedAssetCycleList: new Set(),
        trackAction: null,
        showToolbarBtn: false,
        showMultipleDeleteToolbarBtn: false,
        deleteAssetsOpen: false,
      };
    } else {
      this.state = {
        action: action,
        pageId: pageId,
        returnableCyclePlanId: returnableCyclePlanId,
        assetId: assetId,
        assetCycleId: assetCycleId,
        name: "",
        description: "",
        planDate: new Date(),
        customer: null,
        customerId: "",
        searchText: "",
        assetSearchText: "",
        initialPage: 0,
        pageSize: 10,
        pageNo: 0,
        showPerPage: 10,
        totalPages: 0,
        totalRecords: 0,
        assetPageSize: 10,
        assetPageNo: 0,
        assetShowPerPage: 10,
        assetTotalPages: 0,
        assetTotalRecords: 0,
        isAssetListPaging: false,
        isAssetCycleListPaging: false,
        render: false,
        openListModal: false,
        openManualTrack: false,
        isTrackAtBaseLocation: false,
        isSourceBaselocation: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        assetIds: [],
        planAssets: [],
        assetList: [],
        assetCyclesList: [],
        manulAssetHistoryList: [],
        customerLocationList: [],
        custSourceLocationList: [],
        custDestinaionLocationList: [],
        custLocations: [],
        custLocation: null,
        custSourceAddress: null,
        custDestinationAddress: null,
        selectedPlanAssetList: new Set(),
        selectedAssetList: new Set(),
        selectedAssetCycleList: new Set(),
        trackAction: null,
        showToolbarBtn: false,
        showMultipleDeleteToolbarBtn: false,
        deleteAssetsOpen: false,
      };
    }
    this.debouncedSearch = _.debounce(this.getReturnablePlanDetails, 800);
    this.debouncedGetAssetList = _.debounce(this.getAssetList, 800);
  }
  getReturnablePlanDetails(
    returnableCyclePlanId,
    pageNo,
    pageSize,
    searchText
  ) {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: returnableCyclePlanId,
      },
      page: {
        searchText: searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };

    FetchServerData.callPostService("/returnablePlanms/get", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let returnableCyclePlanData = output.data.returnableCyclePlan;
          let assetCycleList = returnableCyclePlanData.assetCycles;
          let page = output.data.page;
          for (let i = 0; i < assetCycleList?.length; i++) {
            assetCycleList[i].startDate = Utils.getUtcToLocal(
              assetCycleList[i].startDate
            );
            assetCycleList[i].endDate =
              assetCycleList[i].endDate !== null
                ? Utils.getUtcToLocal(assetCycleList[i].endDate)
                : "";
          }
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];

          let isAssetCycleListPaging = false;
          if (assetCycleList.length > this.state.pageSize) {
            isAssetCycleListPaging = true;
          }

          let isAssetListPaging = false;
          if (
            returnableCyclePlanData?.planAssets.length > this.state.pageSize
          ) {
            isAssetListPaging = true;
          }
          this.getLoactionListForCustomer(
            returnableCyclePlanData?.customer?.id
          );
          this.setState({
            render: true,
            action: "view",
            isAssetCycleListPaging: isAssetCycleListPaging,
            isAssetListPaging: isAssetListPaging,
            id: returnableCyclePlanData.id,
            name: returnableCyclePlanData?.name,
            planDate: new Date(returnableCyclePlanData?.planDate),
            description: returnableCyclePlanData.description,
            customer: returnableCyclePlanData.customer,
            customerId: returnableCyclePlanData.customer.id,
            custLocations: returnableCyclePlanData.customer.locations,
            planStatus: returnableCyclePlanData.planStatus,
            planAssets: returnableCyclePlanData.planAssets,
            assetCyclesList: assetCycleList,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            canMarkStarted: returnableCyclePlanData.canMarkStarted,
            canMarkCompleted: returnableCyclePlanData.canMarkCompleted,
            isSourceBaselocation: returnableCyclePlanData.isSourceBaselocation,
            custSourceAddress:
              returnableCyclePlanData?.sourceLocation !== null
                ? returnableCyclePlanData?.sourceLocation
                : returnableCyclePlanData?.baseLocation,
            custDestinationAddress: returnableCyclePlanData.destinationLocation,
            allCheckBoxSelected: false,
            allPlanAssetsSelected: false,
            searchText: page?.searchText,
            pageNo: page?.pageNo,
            showPerPage: page?.pageSize,
            totalPages: page?.totalPages,
            totalRecords: page?.total,
          });
        }
      }
    );
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value });
  }

  handlePlanDateChange(data) {
    this.setState({ planDate: data });
  }

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleCustomerTypeChange(selectedCustomer) {
    this.getLoactionListForCustomer(selectedCustomer?.id);
    this.setState({
      customer: selectedCustomer,
      customerId: selectedCustomer.id,
    });
  }

  getLoactionListForCustomer(customerId) {
    const postObject = {
      header: this.header,
      customerLocation: {
        customer: {
          id: customerId,
        },
      },
    };
    FetchServerData.callPostService(
      "/costomerLocationms/getForCustomer",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let customerLocationList = output.data.customerLocationList;
        this.setState({
          customerLocationList: customerLocationList,
          custSourceLocationList: customerLocationList,
          custDestinaionLocationList: customerLocationList,
        });
      }
    });
  }

  handleIsSourceBaselocationChange(e) {
    this.setState({
      isSourceBaselocation: e.target.checked,
    });
  }
  handleCustSourceAddressChange(selectedLocation) {
    const filteredList = this.state.customerLocationList?.filter(
      (loc) => loc.id !== selectedLocation?.id
    );
    this.setState({
      custSourceAddress: selectedLocation,
      custDestinaionLocationList: filteredList,
    });
  }
  handleCusDestinationAddressChange(selectedLocation) {
    const filteredList = this.state.customerLocationList?.filter(
      (loc) => loc.id !== selectedLocation?.id
    );
    this.setState({
      custDestinationAddress: selectedLocation,
      custSourceLocationList: filteredList,
    });
  }

  createReturnablePlanToBackend() {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        name: this.state.name,
        planDate: this.state.planDate,
        description: this.state.description,
        customer: {
          id: this.state.customerId,
        },
        isSourceBaselocation: this.state.isSourceBaselocation,
        sourceLocation: { id: this.state.custSourceAddress?.id },
        destinationLocation: { id: this.state.custDestinationAddress?.id },
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/create",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let returnablePlanData = output.data.returnableCyclePlan;
        this.getReturnablePlanDetails(returnablePlanData?.id);
        this.setState({
          action: "view",
        });
      }
    });
  }

  createCancel() {
    this.props.navigate("/returnablePlanList");
  }

  viewCancel() {
    if (this.state.pageId === "assetPlanDetails") {
      this.props.navigate("/asset", {
        state: {
          assetId: this.state.assetId,
          action: "view",
        },
      });
    } else if (this.state.pageId === "assetCycleDetails") {
      this.props.navigate("/assetCycle", {
        state: {
          assetCycleId: this.state.assetCycleId,
          action: "view",
        },
      });
    } else {
      this.props.navigate("/returnablePlanList",{});
    }
  }
  editCancel() {
    this.getReturnablePlanDetails(this.state.id);
    // this.setState({
    //   action: "view",
    // })
  }

  editReturnablePlanDetails(e) {
    let filteredsourceLocation = [];
    let filteredDestinationLocation = [];
    if (this.state.custSourceAddress !== null) {
      filteredDestinationLocation = this.state.customerLocationList?.filter(
        (loc) => loc.id !== this.state.custSourceAddress?.id
      );
    }

    if (this.state.custDestinationAddress !== null) {
      filteredsourceLocation = this.state.customerLocationList?.filter(
        (loc) => loc.id !== this.state.custDestinationAddress?.id
      );
    }
    this.setState({
      action: "edit",
      returnableCyclePlanId: this.state.id,
      custSourceLocationList: filteredsourceLocation,
      custDestinaionLocationList: filteredDestinationLocation,
    });
  }

  updateReturnablePlanToBackend(e) {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.id,
        name: this.state.name,
        planDate: this.state.planDate,
        description: this.state.description,
        customer: {
          id: this.state.customerId,
        },
        isSourceBaselocation: this.state.isSourceBaselocation,
        sourceLocation: { id: this.state.custSourceAddress?.id },
        destinationLocation: { id: this.state.custDestinationAddress?.id },
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/update",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let returnablePlanData = output.data.returnableCyclePlan;
        this.getReturnablePlanDetails(
          returnablePlanData.id,
          this.state.pageNo,
          this.state.pageSize,
          ""
        );
      }
    });
  }

  deleteReturnablePlanToBackend() {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.id,
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/delete",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.props.navigate("/returnablePlanList");
      }
    });
  }

  getAssetList(pageNo, pageSize, searchText) {
    const postObject = {
      header: this.header,
      page: {
        searchText: searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
      customer: {
        id: this.state.customerId,
      },
    };
    FetchServerData.callPostService(
      "/costomerms/getActiveAssetList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let assetList = output.data.assetList;
        let page = output.data.page;
        this.setState({
          assetList: assetList,
          assetPageNo: page?.pageNo,
          assetShowPerPage: page?.pageSize,
          assetTotalPages: page?.totalPages,
          assetTotalRecords: page?.total,
        });
      }
    });
  }

  // onAssetCheckBoxSelect(data) {
  //   let assetIds = [];
  //   for (let i = 0; i < data.length; i++) {
  //     const assetId = data[i].id;
  //     assetIds = [...assetIds, assetId];
  //   }
  //   this.setState({
  //     assetIds: assetIds,
  //     manulAssetHistoryList: data,
  //   });
  // }

  async addAssets() {
    await this.getAssetList(0, 10, "");
    this.setState({
      openListModal: true,
    });
  }

  addReturnableAssetToList() {
    let assetIds = [];
    for (let i = 0; i < this.state.assetList.length; i++) {
      if (this.state.assetList[i]?.value === true) {
        assetIds.push(this.state.assetList[i].id);
      }
    }

    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.id,
      },
      assetIds: assetIds,
    };
    FetchServerData.callPostService(
      "/returnablePlanms/addAssets",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let returnableCycleAssetData = output.data.returnableCyclePlan;
        let page = output.data.page;
        PtsAlert.success(output.message);
        let isAssetListPaging = false;
        if (returnableCycleAssetData.planAssets.length > this.state.pageSize) {
          isAssetListPaging = true;
        }
        this.setState({
          allAssetCheckBoxSelected: false,
          selectedAssetList: new Set(),
          selectedPlanAssetList: new Set(),
          isAssetListPaging: isAssetListPaging,
          action: "view",
          planAssets: returnableCycleAssetData.planAssets,
          openListModal: !this.state.openListModal,
          returnableCyclePlanId: returnableCycleAssetData.id,
          searchText: page?.searchText,
          pageNo: page?.pageNo,
          showPerPage: page?.pageSize,
          totalPages: page?.totalPages,
          totalRecords: page?.total,
        });
      }
    });
  }

  toggle = () => {
    this.setState({
      openListModal: !this.state.openListModal,
    });
  };

  deleteReturnablePlanAsset(e, data) {
    let assetId = data.id;
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.returnableCyclePlanId,
      },
      assetIds: [assetId],
      page: {
        searchText: "",
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/deleteAssets",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let returnablePlanAssetData = output.data.returnableCyclePlan;
        let page = output.data.page;
        this.setState({
          action: "view",
          planAssets: returnablePlanAssetData.planAssets,
          searchText: page?.searchText,
          pageNo: page?.pageNo,
          showPerPage: page?.pageSize,
          totalPages: page?.totalPages,
          totalRecords: page?.total,
        });
      }
    });
  }

  handleDeleteAssetsOpen() {
    this.setState({
      deleteAssetsOpen: true,
    });
  }
  handleDeleteAssetsClose() {
    this.setState({
      deleteAssetsOpen: false,
    });
  }

  deleteReturnablePlanAssets() {
    let assetIds = [];
    this.state.selectedPlanAssetList.forEach((element) => {
      assetIds.push(element.id);
    });
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.returnableCyclePlanId,
      },
      assetIds: assetIds,
      page: {
        searchText: "",
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/deleteAssets",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let returnablePlanAssetData = output.data.returnableCyclePlan;
        let page = output.data.page;
        this.setState({
          action: "view",
          deleteAssetsOpen: false,
          showMultipleDeleteToolbarBtn: false,
          allPlanAssetsSelected: false,
          planAssets: returnablePlanAssetData.planAssets,
          searchText: page?.searchText,
          pageNo: page?.pageNo,
          showPerPage: page?.pageSize,
          totalPages: page?.totalPages,
          totalRecords: page?.total,
        });
      }
    });
  }

  getStartPlan() {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.returnableCyclePlanId,
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/startPlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        store.dispatch(ApplicationStateAction.setApplicationState({}));
        let planAssets = output.data.returnableCyclePlan.planAssets;
        let assetIds = [];
        for (let i = 0; i < planAssets.length; i++) {
          assetIds.push(planAssets[i].id);
        }
        this.props.navigate("/assetCycleList", {
          state: {
            pageid: "/assetCycleList",
            assetCycleIds: assetIds,
          },
        });
        this.setState({
          planAssets: planAssets,
        });
      }
    });
  }

  getCompletedPlan() {
    const postObject = {
      header: this.header,
      returnableCyclePlan: {
        id: this.state.returnableCyclePlanId,
      },
    };
    FetchServerData.callPostService(
      "/returnablePlanms/markComplete",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let returnableCyclePlan = output.data.returnableCyclePlan;
        let returnablePlanState = {
          initialPage: this.state.initialPage,
          pageSize: this.state.pageSize,
          selectedTab: 2,
          returnablePlanId: returnableCyclePlan.id,
        };
        store.dispatch(
          ApplicationStateAction.setApplicationState({ returnablePlanState })
        );
        this.props.navigate("/returnablePlanList");
      }
    });
  }

  toAssetCycleDetails(e, data) {
    let returnableAssetCycleState = {
      assetCycleId: data.id,
      returnablePlanId: this.state.id,
      initialPage: this.state.initialAssetCyclePage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ returnableAssetCycleState })
    );
    this.props.navigate("/assetCycle", {
      state: {
        action: "view",
        assetCycleId: data.id,
        returnablePlanId: this.state.id,
        pageId: "returnablePlanDetails",
      },
    });
  }
  toPlanAssetListDetails(e, data) {
    let returnableAssetState = {
      assetId: data.id,
      returnablePlanId: this.state.id,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ returnableAssetState })
    );
    this.props.navigate("/asset", {
      state: {
        action: "view",
        assetId: data.id,
        returnablePlanId: this.state.id,
        pageId: "returnablePlanDetails",
      },
    });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }
  handleAssetCycleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialAssetCyclePage: page, pageSize: pageSize });
  }

  onPlanAssetSelect(e, data, index) {
    const isChecked = e.target.checked;
    const selectedPlanAssetList = new Set(this.state.selectedPlanAssetList);

    if (isChecked) {
      selectedPlanAssetList.add(data); // Add full object
    } else {
      // Remove matching object by ID
      for (let item of selectedPlanAssetList) {
        if (item.id === data.id) {
          selectedPlanAssetList.delete(item);
          break;
        }
      }
    }

    // Clone and update planAssets
    const planAssets = [...this.state.planAssets];
    planAssets[index] = { ...planAssets[index], value: isChecked };

    this.setState({
      selectedPlanAssetList,
      planAssets,
      allPlanAssetsSelected:
        selectedPlanAssetList.size === this.state.assetShowPerPage,
      showMultipleDeleteToolbarBtn: selectedPlanAssetList.size > 0,
    });
  }

  allPlanAssetsSelected(e) {
    const isChecked = e.target.checked;
    const selectedPlanAssetList = new Set();
    const planAssets = this.state.planAssets.map((asset) => {
      if (isChecked) {
        selectedPlanAssetList.add(asset);
      }
      return { ...asset, value: isChecked };
    });

    this.setState({
      selectedPlanAssetList,
      planAssets,
      allPlanAssetsSelected: isChecked,
      showMultipleDeleteToolbarBtn: isChecked,
    });
  }

  toAssetDetails(assetId) {
    console.log(this.state.id);
    this.props.navigate("/asset", {
      state: {
        action: "view",
        assetId: assetId,
        assetCycleId: this.state.assetCycleId,
        returnablePlanId: this.state.id,
        pageId: "returnablePlanDetails",
      },
    });
  }

  onAssetPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.assetPageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.assetList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].value = false;
      this.setState({
        allAssetCheckBoxSelected: false,
      });
    }
    this.setState({
      assetPageNo: currentPageIndex,
      assetShowPerPage: pageSize,
    });
    this.getAssetList(currentPageIndex, pageSize);
    this.handleMaterialTablePageChange(currentPageIndex, pageSize);
  }

  onAssetCheckBoxSelect(e, data, index) {
    let selectedItems = [...this.state.assetList];
    // let isChecked = e.target.checked;
    // if (isChecked) {
    //   this.state.selectedAssetList.add(data);
    // } else {
    //   this.state.selectedAssetList.delete(data);
    // }
    // data.value = isChecked;

    selectedItems.forEach((item) => {
      if (item.id === data.id) {
        item.value = e.target.checked;
      }
    });

    // Check if all checkboxes are selected
    const allChecked = selectedItems.every((item) => item.value);
    this.setState({
      allAssetCheckBoxSelected: allChecked,
      selectedAssetList: selectedItems,
    });
  }
  onAllAssetCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.assetList;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onAssetCheckBoxSelect(e, row, i);
    }
    this.setState({
      allAssetCheckBoxSelected: isChecked,
    });
  }

  onAssetSearchChange(e) {
    let search = e.target.value;
    this.setState({ assetSearchText: search });
    this.debouncedGetAssetList(
      this.state.assetPageNo,
      this.state.assetPageSize,
      search
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.assetCyclesList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].value = false;
      this.setState({
        allCheckBoxSelected: false,
      });
    }
    this.setState({
      pageNo: currentPageIndex,
      showPerPage: pageSize,
    });
    this.getReturnablePlanDetails(this.state.id, currentPageIndex, pageSize);
    this.debouncedSearch = _.debounce(this.getReturnablePlanDetails, 800);
  }

  onSearchTextChange(e) {
    const search = e.target.value;
    this.setState({ searchText: search });
    this.debouncedSearch(
      this.state.id,
      this.state.pageNo,
      this.state.pageSize,
      search
    );
  }

  onSearchClick() {
    this.setState({
      isFirstTimeLoading: false,
    });
    this.getAssetList(
      this.state.assetPageNo,
      this.state.assetShowPerPage,
      this.state.assetSearchText
    );
  }

  onAssetCycleSelect(e, data, index) {
    let isChecked = e.target.checked;
    if (isChecked) {
      this.state.selectedAssetCycleList.add(data);
    } else {
      this.state.selectedAssetCycleList.delete(data);
    }
    data.value = isChecked;
    this.setState({
      allAssetCyclesSelected:
        this.state.selectedAssetCycleList.size === this.state.showPerPage,
      showToolbarBtn: this.state.selectedAssetCycleList.size > 0 ? true : false,
      selectedAssetCycleList: this.state.selectedAssetCycleList,
    });
  }

  allAssetCyclesSelected(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.assetCyclesList;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onAssetCycleSelect(e, row, i);
    }
    this.setState({
      allAssetCyclesSelected: isChecked,
    });
  }

  manulAssetHistory() {
    let assetCycleIdList = [];
    this.state.selectedAssetCycleList.forEach((element) => {
      assetCycleIdList.push(element.id);
    });
    const postObject = {
      header: this.header,
      assetCycleIdList: assetCycleIdList,
      action: this.state.trackAction?.type,
      custLocation: this.state.custLocation?.id,
      isTrackAtBaseLocation: this.state.isTrackAtBaseLocation,
    };
    FetchServerData.callPostPtsTracking(
      "/history/manulCycleHistory",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.getReturnablePlanDetails(
          this.state.returnableCyclePlanId,
          this.state.pageNo,
          this.state.pageSize,
          this.state.searchText
        );
        this.setState({
          action: "view",
          custLocation: null,
          trackAction: null,
          openManualTrack: false,
          isTrackAtBaseLocation: false,
          allAssetCyclesSelected: false,
          showToolbarBtn: false,
        });
      }
    });
  }

  assetTrackingStatus(trackingHistoryStatus) {
    switch (trackingHistoryStatus) {
      case "Active":
        return <span className="dot"></span>;
      case "NotTracked":
        return <span className="dot"></span>;
      case "Tracked":
        return <span className="greendot"></span>;
      case "HoldingPeriodOver":
        return <span className="yellowdot blink_me"></span>;
      case "CycleTimeOver":
        return <span className="orangedot blink_me"></span>;
      case "MissingAsset":
        return <span className="reddot blink_me"></span>;
      default:
    }
  }

  handleManualTrackOpen() {
    this.setState({
      openManualTrack: true,
    });
  }
  handleManualTrackClose() {
    this.setState({
      openManualTrack: false,
    });
  }

  handleCustomerLocationChange(location) {
    this.setState({ custLocation: location });
  }
  handleTrackActionChange(action) {
    this.setState({ trackAction: action });
  }
  handleTrackAtBaseLocationChange(e) {
    this.setState({
      isTrackAtBaseLocation: e.target.checked,
    });
  }

  render() {
    if (this.state.action === "create") {
      return this.createReturnablePlan();
    } else if (this.state.action === "view") {
      return this.viewReturnablePlan();
    } else if (this.state.action === "edit") {
      return this.editReturnablePlan();
    }
  }

  createReturnablePlan() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Returnable Plan"
          name="Create Returnable Plan"
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createReturnablePlanToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card " id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Returnable Plan Details
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                        >
                          Customer <span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          disableClearable
                          id="customerTypeList"
                          options={this.customerList}
                          value={this.state.customer}
                          defaultValue={this.state.customer}
                          getOptionLabel={(option) => option.name}
                          onChange={(event, value) => {
                            this.handleCustomerTypeChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Name<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-name"
                          variant="outlined"
                          value={this.state.name}
                          onChange={this.handleNameChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Plan Date
                        </label>
                        <DatePicker
                          selected={this.state.planDate}
                          onChange={this.handlePlanDateChange.bind(this)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Start Date*"
                          required
                          className="planDateTimeInput"
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div
                        className="col-md-4 align-self-center formControlLabel"
                        id="assetFormLabel"
                      >
                        <FormControlLabel
                          style={{
                            // color: "#000",
                            margin: "0",
                            padding: "0",
                            height: "15px",
                          }}
                          control={
                            <Checkbox
                              variant="outlined"
                              id="isAsset"
                              checked={this.state.isSourceBaselocation}
                              value={this.state.isSourceBaselocation}
                              onChange={this.handleIsSourceBaselocationChange.bind(
                                this
                              )}
                              style={{
                                background: "none",
                              }}
                            />
                          }
                          label={
                            <span
                              className="m-1 form-label"
                              style={{ textTransform: "inherit" }}
                            >
                              Is base location the same as source location?
                            </span>
                          }
                        />
                      </div>
                      {this.state.isSourceBaselocation ? (
                        <div className="col-md-4" id="assetFormLabel">
                          <label
                            className="form-label"
                            htmlFor="collapsible-supplierType"
                          >
                            Source Address
                          </label>
                          <div className="row">
                            <div className="col-md-12">
                              {Utils.getAddressAsText(this.organizationAddress)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-4" id="assetFormLabel">
                          <label
                            className="form-label"
                            htmlFor="collapsible-supplierType"
                          >
                            Source Address <span className="asterisk"> *</span>
                          </label>
                          <Autocomplete
                            fullWidth
                            // disableClearable
                            id="customerTypeList"
                            options={this.state.custSourceLocationList}
                            value={this.state.custSourceAddress}
                            defaultValue={this.state.custSourceAddress}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, value) => {
                              this.handleCustSourceAddressChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                              />
                            )}
                          />
                        </div>
                      )}
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label"
                          htmlFor="collapsible-supplierType"
                        >
                          Destination Address
                          <span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          // disableClearable
                          id="customerTypeList"
                          options={this.state.custDestinaionLocationList}
                          value={this.state.custDestinationAddress}
                          defaultValue={this.state.custDestinationAddress}
                          getOptionLabel={(option) => option.name}
                          onChange={(event, value) => {
                            this.handleCusDestinationAddressChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-description"
                        >
                          Description
                        </label>
                        <textarea
                          name="collapsible-address"
                          className="form-control"
                          style={{
                            color: "black",
                            font: "inherit",
                            fontSize: "16px ",
                          }}
                          id="collapsible-address"
                          rows="4"
                          value={this.state.description}
                          onChange={this.handleDescriptionChange.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between custBut">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }

  viewReturnablePlan() {
    const checkedCount = this.state.planAssets?.filter(
      (item) => item?.value === true
    )?.length;

    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject={this.state.name}
            name="Returnable Plan Details"
            title="Returnable Plan"
            pageId="AssetView"
            editCallback={this.editReturnablePlanDetails.bind(this)}
            deleteCallback={this.deleteReturnablePlanToBackend.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
            assetCycleId={this.state.assetCycleId}
            returnableCyclePlanId={this.state.returnableCyclePlanId}
          />
          <div className="row" style={{ padding: "1em", marginTop: "-12px" }}>
            <div className="card" id="organizationFormCard">
              <div className="row">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h5 className="mb-0" id="headerLabel">
                    {this.state.name}
                  </h5>
                </div>
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="row pt-2">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Name
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>{this.state.name}</span>
                        </div>
                      </div>
                      <div className="row pt-2">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Status
                        </label>
                        <div className="col-sm-8" id="OrganizationCol">
                          <span>
                            {this.state.planStatus != null
                              ? this.state.planStatus.status
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row pt-2">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Plan Date
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>
                                {Utils.getUtcToLocalDateTime(
                                  this.state.planDate
                                )}
                              </span>
                            </div>
                          </div>
                          {/* <div className="row pt-2">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Discription
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>{this.state.description}</span>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="row pt-2">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Customer
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>
                                {this.state.customer != null
                                  ? this.state.customer.name
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="row pt-2">
                        <label
                          className="col-sm-12 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Description
                        </label>
                        <br></br>
                        <div className="col-sm-12" id="OrganizationCol">
                          <span>{this.state.description}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 mt-4 mb-4">
                      <div className="row">
                        <div className="col-sm-12 text-start">
                          {this.state.canMarkStarted &&
                            this.state.planAssets.length > 0 ? (
                            <button
                              className="startPlanBtton"
                              type="submit"
                              onClick={(e) => this.getStartPlan()}
                            >
                              Start Plan
                            </button>
                          ) : (
                            ""
                          )}
                          {this.state.canMarkCompleted && (
                            <button
                              className="startPlanBtton"
                              type="submit"
                              onClick={(e) => this.getCompletedPlan()}
                            >
                              Mark Completed
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row">
                      <div className="col-md-4 ps-2">
                        <div
                          className="card-header d-flex align-items-center justify-content-between p-2"
                          id="assetCardHeader"
                        >
                          <h5 className="mb-0" id="headerLabel">
                            Source Address
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12 p-0">
                              <div className="row pt-2 text-start">
                                <span>
                                  {this.state.custSourceAddress?.address
                                    ? this.state.custSourceAddress?.address
                                    : Utils.getAddressAsText(
                                      this.state.custSourceAddress
                                    )}
                                </span>
                              </div>
                            </div>
                            {this.state.custSourceAddress !== null &&
                              this.state.custSourceAddress?.latitude !== null ? (
                              <div className="col-md-12 p-0">
                                <div className="row text-start mt-2 d-flex">
                                  <div className="col-md-4">
                                    <span className="mb-0" id="headerLabel">
                                      Geolocation
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-8 text-start"
                                    style={{ marginLeft: "-25px" }}
                                  >
                                    <span>
                                      {this.state.custSourceAddress?.latitude +
                                        " , " +
                                        this.state.custSourceAddress?.longitude}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="card-header d-flex align-items-center justify-content-between p-2"
                          id="assetCardHeader"
                        >
                          <h5 className="mb-0" id="headerLabel">
                            Destination Address
                          </h5>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12 p-0">
                              <div className="row pt-2 text-start">
                                <span>
                                  {this.state.custDestinationAddress !== null
                                    ? this.state.custDestinationAddress?.address
                                    : ""}
                                </span>
                              </div>
                            </div>
                            {this.state.custDestinationAddress !== null &&
                              this.state.custDestinationAddress?.latitude !==
                              null ? (
                              <div className="col-md-12 p-0">
                                <div className="row text-start mt-2 d-flex">
                                  <div className="col-md-4">
                                    <span className="mb-0" id="headerLabel">
                                      Geolocation
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-8 text-start"
                                    style={{ marginLeft: "-25px" }}
                                  >
                                    <span>
                                      {this.state.custDestinationAddress
                                        ?.latitude +
                                        " , " +
                                        this.state.custDestinationAddress
                                          ?.longitude}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.planStatus.status === "Planned" && (
            <div className="materialTable" style={{ padding: "3px" }}>
              <div className="row">
                <div className="col md-12">
                  <div className="card">
                    <div className="row justify-content-between p-3">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="col-12 text-start totalResults">
                          <span>Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}</span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <>
                            {this.state.showMultipleDeleteToolbarBtn && (
                              <PtsButton
                                btnName="Remove Assets"
                                onClick={this.handleDeleteAssetsOpen.bind(this)}
                              />
                            )}
                            <span className="ms-4 me-4">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="search"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchTextChange.bind(this)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={this.getReturnablePlanDetails.bind(
                                          this,
                                          this.state.id,
                                          this.state.pageNo,
                                          this.state.pageSize,
                                          this.state.searchText
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                            <PtsButton
                              btnName="Add Assets"
                              onClick={(event) => this.addAssets()}
                            />
                          </>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold ">
                              {" "}
                              <input
                                type="checkbox"
                                checked={this.state.allPlanAssetsSelected}
                                onChange={this.allPlanAssetsSelected.bind(this)}
                              />
                            </th>
                            <th scope="col fw-bold">Asset Name</th>
                            <th scope="col fw-bold">Asset UID</th>
                            <th scope="col fw-bold">Asset Code</th>
                            <th scope="col fw-bold">Status</th>
                            <th scope="col fw-bold">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.planAssets?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.assetId
                                    ? "#e6effc"
                                    : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <td>
                                {/* {this.state.pageNo * this.state.showPerPage +
                                  index +
                                  1} */}
                                <input
                                  type="checkbox"
                                  checked={
                                    rowData.value ||
                                    this.state.allPlanAssetsSelected
                                  }
                                  onChange={(e) =>
                                    this.onPlanAssetSelect(e, rowData, index)
                                  }
                                />
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.name}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.uid}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.assetcode}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.status}
                              </td>
                              <td
                                style={{ width: "10%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                <div key={rowData.id}>
                                  <span
                                    style={{
                                      display: "flex",
                                      marginLeft: "-7px",
                                    }}
                                  >
                                    <RemoveIconButton
                                      className="actionBtn"
                                      btnName="Remove"
                                      pageId="returnableAsset"
                                      domainObject={rowData.uid}
                                      onClick={(e) =>
                                        this.deleteReturnablePlanAsset(
                                          e,
                                          rowData
                                        )
                                      }
                                    />
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div className="row text-center p-2">
                        <h5>Data not Available</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-2">
                        <div className="pageSize col-4 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                        <div className="col-4 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                            pageNo={this.state.pageNo}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.planStatus.status === "Started" && (
            <>
              <div className="row">
                <div className="col md-12">
                  <div className="card">
                    <div className="row justify-content-between p-3">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="col-12 text-start totalResults">
                          <span>Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}</span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <>
                            <span className="me-4">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="search"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchTextChange.bind(this)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={this.getReturnablePlanDetails.bind(
                                          this,
                                          this.state.id,
                                          this.state.pageNo,
                                          this.state.pageSize,
                                          this.state.searchText
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                            <button
                              id="ptsButton"
                              type="submit"
                              className="btn btn-default "
                              onClick={(event) => this.handleManualTrackOpen()}
                            >
                              Manual Asset Track
                            </button>
                          </>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold ">
                              <input
                                type="checkbox"
                                checked={this.state.allAssetCyclesSelected}
                                onChange={this.allAssetCyclesSelected.bind(
                                  this
                                )}
                              />
                            </th>
                            <th scope="col fw-bold">Customer</th>
                            <th scope="col fw-bold">Plan Name</th>
                            <th scope="col fw-bold">Asset Name</th>
                            <th scope="col fw-bold">Asset UID</th>
                            <th scope="col fw-bold">Asset Code</th>
                            <th scope="col fw-bold">Start Date</th>
                            <th scope="col fw-bold">End Date</th>
                            <th scope="col fw-bold">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.assetCyclesList?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.assetId
                                    ? "#e6effc"
                                    : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              {/* <td>{this.state.pageNo * this.state.showPerPage + index + 1}</td> */}
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    rowData.value ||
                                    this.state.allAssetCyclesSelected
                                  }
                                  onChange={(e) =>
                                    this.onAssetCycleSelect(e, rowData, index)
                                  }
                                />
                              </td>
                              <td
                                style={{ width: "13%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.customerName}
                              </td>
                              <td
                                style={{ width: "11%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.cycleplanName}
                              </td>
                              <td
                                style={{ width: "12%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.assetName}
                              </td>
                              <td
                                style={{ width: "10%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.assetUid}
                              </td>
                              <td
                                style={{ width: "12%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.assetCode}
                              </td>
                              <td
                                style={{ width: "12%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.startDate}
                              </td>
                              <td
                                style={{ width: "12%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.endDate}
                              </td>
                              <td
                                style={{ width: "12%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.assetId
                                )}
                              >
                                {rowData.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div className="row text-center p-2">
                        <h5>Data not Available</h5>
                      </div>
                    )}
                    {this.state.totalRecords > 10 && (
                      <div className="row justify-content-between pagination p-2">
                        <div className="pageSize col-4 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                        <div className="col-4 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                            pageNo={this.state.pageNo}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          {this.state.planStatus.status !== "Planned" &&
            this.state.planStatus.status !== "Started" && (
              <>
                <div className="row">
                  <div className="col md-12">
                    <div className="card">
                      <div className="row justify-content-between p-3">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="col-12 text-start totalResults">
                            <span>
                              Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <>
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="search"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchTextChange.bind(this)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={this.getReturnablePlanDetails.bind(
                                          this,
                                          this.state.id,
                                          this.state.pageNo,
                                          this.state.pageSize,
                                          this.state.searchText
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTable">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold ">#</th>
                              <th scope="col fw-bold">Customer</th>
                              <th scope="col fw-bold">Plan Name</th>
                              <th scope="col fw-bold">Asset Name</th>
                              <th scope="col fw-bold">Asset UID</th>
                              <th scope="col fw-bold">Asset Code</th>
                              <th scope="col fw-bold">Start Date</th>
                              <th scope="col fw-bold">End Date</th>
                              <th scope="col fw-bold">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.assetCyclesList?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.assetId
                                        ? "#e6effc"
                                        : "#fff",
                                    cursor: "pointer",
                                  }}
                                  onClick={this.toAssetDetails.bind(
                                    this,
                                    rowData.assetId
                                  )}
                                >
                                  <td>
                                    {this.state.pageNo *
                                      this.state.showPerPage +
                                      index +
                                      1}
                                  </td>
                                  <td
                                    style={{ width: "13%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.customerName}
                                  </td>
                                  <td
                                    style={{ width: "11%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.cycleplanName}
                                  </td>
                                  <td
                                    style={{ width: "12%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.assetName}
                                  </td>
                                  <td
                                    style={{ width: "10%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.assetUid}
                                  </td>
                                  <td
                                    style={{ width: "12%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.assetCode}
                                  </td>
                                  <td
                                    style={{ width: "12%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.startDate}
                                  </td>
                                  <td
                                    style={{ width: "12%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.endDate}
                                  </td>
                                  <td
                                    style={{ width: "12%" }}
                                  // onClick={(e) => this.viewAsset(e, rowData)}
                                  >
                                    {rowData.status}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {this.state.totalRecords === 0 && (
                        <div className="row text-center p-2">
                          <h5>Data not Available</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-2">
                          <div className="pageSize col-4 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                          <div className="col-4 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                              pageNo={this.state.pageNo}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

          <div className="mt-4">
            <BackButton
              type="button"
              style={{ backgroundColor: "#162c50", color: "#fff" }}
              variant="contained"
              onClick={(e) => this.viewCancel()}
            >
              Back
            </BackButton>
          </div>
          <Modal
            isOpen={this.state.openListModal}
            toggle={this.toggle}
            size="lg"
          >
            <Row>
              <Col md={12}>
                <div style={{ maxWidth: "100%" }}>
                  <div className="row">
                    <div className="col md-12">
                      <div className="row justify-content-between p-3">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="col-12 text-start totalResults">
                            <span>
                              Total Results: {Utils.formatIndianNumber(this.state.assetTotalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            {/* <input
                              type="search"
                              id="gsearch"
                              // style={{ width: "240px", height: "33px", outline: "none" }}
                              placeholder="Search"
                              name="gsearch"
                              value={this.state.assetSearchText}
                              onChange={this.onAssetSearchChange.bind(this)}
                            />
                            <button
                              className="gsearchButton"
                              onClick={this.onSearchClick.bind(this)}
                            >
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="search"
                              variant="standard"
                              value={this.state.assetSearchText}
                              onChange={this.onAssetSearchChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={this.getAssetList.bind(
                                        this,
                                        this.state.assetPageNo,
                                        this.state.assetPageSize,
                                        this.state.assetSearchText
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="table-responsive"
                        style={{ height: "415px", overflow: "auto" }}
                      >
                        <table className="table text-start table-hover mb-0">
                          <thead className="assetCycleThead">
                            <tr>
                              <th scope="col fw-bold ">
                                <input
                                  type="checkbox"
                                  checked={this.state.allAssetCheckBoxSelected}
                                  onChange={this.onAllAssetCheckBoxSelect.bind(
                                    this
                                  )}
                                />
                              </th>
                              <th scope="col fw-bold">Name</th>
                              <th scope="col fw-bold">Asset UID</th>
                              <th scope="col fw-bold">Asset Code</th>
                              <th scope="col fw-bold">Asset Type</th>
                              <th scope="col fw-bold">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.assetList?.map((rowData, index) => (
                              <tr
                                key={index}
                                style={{
                                  backgroundColor:
                                    rowData?.id === this.state.assetId
                                      ? "#e6effc"
                                      : "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                {/* <td>{this.state.pageNo * this.state.showPerPage + index + 1}</td> */}
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={
                                      rowData.value ||
                                      this.state.allAssetCheckBoxSelected
                                    }
                                    onChange={(e) =>
                                      this.onAssetCheckBoxSelect(
                                        e,
                                        rowData,
                                        index
                                      )
                                    }
                                  />
                                </td>
                                <td style={{ width: "300px" }}>
                                  {rowData.name}
                                </td>
                                <td style={{ width: "260px" }}>
                                  {rowData.uid}
                                </td>
                                <td style={{ width: "260px" }}>
                                  {rowData.assetcode}
                                </td>
                                <td style={{ width: "220px" }}>
                                  {rowData.assetType}
                                </td>
                                <td style={{ width: "220px" }}>
                                  {rowData.status}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {this.state.assetTotalRecords === 0 && (
                        <div className="row text-center p-2">
                          <h5>Data not Available</h5>
                        </div>
                      )}
                      {this.state.assetTotalRecords > 10 && (
                        <div className="row justify-content-between pagination ps-2">
                          <div className="pageSize col-4 text-start">
                            Page {this.state.assetPageNo + 1} of{" "}
                            {this.state.assetTotalPages}
                          </div>
                          <div className="col-4 text-end">
                            <Pagination
                              showPerPage={this.state.assetShowPerPage}
                              onPaginationChange={this.onAssetPaginationChange.bind(
                                this
                              )}
                              total={this.state.assetTotalRecords}
                              pageNo={this.state.assetPageNo}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <hr className="m-0"></hr>
            <ModalFooter>
              <Col style={{ textAlign: "center", paddingTop: "10px" }}>
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    background: "#ef6603",
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) => this.addReturnableAssetToList()}
                >
                  Add Assets
                </Button>
                &nbsp; &nbsp;
                <CancelIconButton onClick={(e) => this.toggle()} />
              </Col>
            </ModalFooter>
          </Modal>
          <Dialog
            open={this.state.openManualTrack}
            onClose={this.handleManualTrackClose.bind(this)}
            maxWidth="xl"
            className="menulTrackDialogue"
          >
            <DialogTitle
              id="scroll-dialog-title"
              style={{ backgroundColor: "#0B6F9D", padding: "8px 24px" }}
            >
              <span style={{ color: "#fff" }}>Manual Asset Track</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleManualTrackClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            {!this.state.showToolbarBtn ? (
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  // fontSize: "small",
                  padding: "1em",
                  textAlign: "center",
                }}
              >
                Please select assets.
              </div>
            ) : (
              <ValidatorForm
                ref="form"
                onSubmit={this.manulAssetHistory.bind(this)}
              >
                <DialogContent>
                  <div
                    md={12}
                    style={{
                      width: "100%",
                      color: "#000",
                      fontSize: "small",
                      padding: "1em",
                    }}
                  >
                    <div className="col-sm-12 mb-3 formControlLabel">
                      <FormControlLabel
                        style={{
                          // color: "#000",
                          margin: "0",
                          padding: "0",
                          height: "15px",
                        }}
                        control={
                          <Checkbox
                            variant="outlined"
                            id="isAsset"
                            checked={this.state.isTrackAtBaseLocation}
                            value={this.state.isTrackAtBaseLocation}
                            onChange={this.handleTrackAtBaseLocationChange.bind(
                              this
                            )}
                            style={{
                              background: "none",
                            }}
                          />
                        }
                        label={
                          <span
                            className="m-1 form-label"
                            style={{ textTransform: "inherit" }}
                          >
                            Track at base location
                          </span>
                        }
                      />
                    </div>
                    {this.state.isTrackAtBaseLocation !== true ? (
                      <div className="col-sm-12">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                          style={{ textTransform: "inherit" }}
                        >
                          Customer Location
                        </label>
                        <Autocomplete
                          fullWidth
                          disableClearable
                          id="customerTypeList"
                          options={this.state.custLocations}
                          value={this.state.custLocation}
                          defaultValue={this.state.custLocation}
                          getOptionLabel={(option) => option.name}
                          onChange={(event, value) => {
                            this.handleCustomerLocationChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </div>
                    ) : (
                      <div className="row d-flex">
                        <div className="col-sm-12">
                          <label
                            className="form-label"
                            htmlFor="collapsible-supplierType"
                            style={{ textTransform: "inherit" }}
                          >
                            Customer Location
                          </label>
                          <div className="col-md-12">
                            {Utils.getAddressAsText(this.organizationAddress)}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-sm-12 mt-2">
                      <label
                        className="form-label "
                        htmlFor="collapsible-supplierType"
                        style={{ textTransform: "inherit" }}
                      >
                        Action
                      </label>
                      <Autocomplete
                        fullWidth
                        required
                        disableClearable
                        id="customerTypeList"
                        options={this.trackActions}
                        value={this.state.trackAction}
                        defaultValue={this.state.trackAction}
                        getOptionLabel={(option) => option.type}
                        onChange={(event, value) => {
                          this.handleTrackActionChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            required
                          />
                        )}
                      />
                    </div>
                  </div>
                </DialogContent>
                <DialogActions className="justify-items-center">
                  <div className="p-2">
                    <PtsButton btnName="Mark Tracked" type="submit" />
                  </div>
                </DialogActions>
              </ValidatorForm>
            )}
          </Dialog>
          <Dialog
            open={this.state.deleteAssetsOpen}
            onClose={this.handleDeleteAssetsClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "16px" }}>
                  {`${checkedCount} assets will be removed from Returnable Plan.`}
                </p>
              </span>
            </DialogContent>
            <DialogActions
              style={{
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                type="button"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={this.deleteReturnablePlanAssets.bind(this)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                type="button"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleDeleteAssetsClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  }

  editReturnablePlan() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Returnable Plan"
          name="Edit Returnable Plan"
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateReturnablePlanToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card " id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Returnable Plan Details
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-supplierType"
                        >
                          Customer <span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          disableClearable
                          id="customerTypeList"
                          options={this.customerList}
                          value={this.state.customer}
                          defaultValue={this.state.customer}
                          getOptionLabel={(option) => option.name}
                          onChange={(event, value) => {
                            this.handleCustomerTypeChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Name<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-name"
                          variant="outlined"
                          value={this.state.name}
                          onChange={this.handleNameChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Plan Date
                        </label>
                        <DatePicker
                          selected={this.state.planDate}
                          onChange={this.handlePlanDateChange.bind(this)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Start Date*"
                          required
                          className="planDateTimeInput"
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div
                        className="col-md-4 align-self-center formControlLabel"
                        id="assetFormLabel"
                      >
                        <FormControlLabel
                          style={{
                            // color: "#000",
                            margin: "0",
                            padding: "0",
                            height: "15px",
                          }}
                          control={
                            <Checkbox
                              variant="outlined"
                              id="isAsset"
                              checked={this.state.isSourceBaselocation}
                              value={this.state.isSourceBaselocation}
                              onChange={this.handleIsSourceBaselocationChange.bind(
                                this
                              )}
                              style={{
                                background: "none",
                              }}
                            />
                          }
                          label={
                            <span
                              className="m-1 form-label"
                              style={{ textTransform: "inherit" }}
                            >
                              Is base location the same as source location?
                            </span>
                          }
                        />
                      </div>
                      {this.state.isSourceBaselocation ? (
                        <div className="col-md-4" id="assetFormLabel">
                          <label
                            className="form-label"
                            htmlFor="collapsible-supplierType"
                          >
                            Source Address
                          </label>
                          <div className="row">
                            <div className="col-md-12">
                              {Utils.getAddressAsText(this.organizationAddress)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-4" id="assetFormLabel">
                          <label
                            className="form-label"
                            htmlFor="collapsible-supplierType"
                          >
                            Source Address <span className="asterisk"> *</span>
                          </label>
                          <Autocomplete
                            fullWidth
                            // disableClearable
                            id="customerTypeList"
                            options={this.state.custSourceLocationList}
                            value={this.state.custSourceAddress}
                            defaultValue={this.state.custSourceAddress}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, value) => {
                              this.handleCustSourceAddressChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                              />
                            )}
                          />
                        </div>
                      )}
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label"
                          htmlFor="collapsible-supplierType"
                        >
                          Destination Address
                          <span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          disableClearable
                          id="customerTypeList"
                          options={this.state.custDestinaionLocationList}
                          value={this.state.custDestinationAddress}
                          defaultValue={this.state.custDestinationAddress}
                          getOptionLabel={(option) => option.name}
                          onChange={(event, value) => {
                            this.handleCusDestinationAddressChange(value);
                          }}
                          inputprops={{
                            style: { textTransform: "capitalize" },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Please Select"
                              variant="outlined"
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-description"
                        >
                          Description
                        </label>
                        <textarea
                          name="collapsible-address"
                          className="form-control"
                          style={{
                            color: "black",
                            font: "inherit",
                            fontSize: "16px ",
                          }}
                          id="collapsible-address"
                          rows="4"
                          value={this.state.description}
                          onChange={this.handleDescriptionChange.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between custBut">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }
}
export default withRouter(ReturnablePlan);
